/* global Provider */
import React, { Component } from 'react';
import Step from './Step';
import QuartileChart from './QuartileChart';

export default class QuartileStep extends Component {
    constructor(props){
        super(props);

        this.graph = null;
        this.getGraphRef = this.getGraphRef.bind(this);
    }

    getGraphRef(element){
        this.graph = element;
    }

    validate(){
        let selected = this.graph.getSelected();
        if (selected.length === 0 || selected.length < 2 || selected.length > 20){
            Provider.showModal('Error', 'Please select between 2 and 20 funds for analysis.');
            return false;
        }else{
            return true;
        }
    }

    render() {
        return (
            <Step className={this.props.className}>
                <h1>TDF Rankings</h1>
                <p>
                Using our evaluation methodology, <em>Target-Date Blueprint</em> has ranked the relative suitability of more than 40 TDFs based on your answers about profile of the plan and its participants. Those ranked in Quartile 1 represent those that most closely match the plan's and participant objectives and risk profile. The TDFs lower quartiles are less aligned with plan and participants risk and objectives.
                </p>
                <p className="mt-2 alert alert-fair text-center font-sm">Click on a fund to select or deselect it. Please select between 2 and 20 funds for analysis.</p>
                <div className="mt-2" style={{ width: '90%', margin: '0 auto' }}>
                    <QuartileChart ref={this.getGraphRef} />
                    <small className="d-block mt-4 text-muted">
                        When American Century is noted, this includes American Century One Choice Portfolios, American Century Retirement Date Hybrid Trust and American Century Retirement Readiness Trust. 
                    </small>
                    <small className="d-block mt-1 text-muted"> 
                        It's <u>also</u> important to compare fees, expenses, performance and risk metrics.                    
                    </small>
                </div>
            </Step>
        );
    }
}
